import { render, staticRenderFns } from "./Ajuste_Stock.vue?vue&type=template&id=89f31f0c&scoped=true"
import script from "./Ajuste_Stock.vue?vue&type=script&lang=js"
export * from "./Ajuste_Stock.vue?vue&type=script&lang=js"
import style0 from "./Ajuste_Stock.vue?vue&type=style&index=0&id=89f31f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f31f0c",
  null
  
)

export default component.exports